export const MB1 = 1024 * 1024;
/**
 * maximum tax id doc size
 */
export const MB2 = MB1 * 2;
